// WHY: the amendments actor reports an undo as plain chat-text, so a save is the only envelope that signals a write
export const assistantEnvelopeUpdates = (message)=>({
        filterUpdate: message.persistedAgreementFilterUpdate(),
        selectionUpdate: message.persistedSelectionUpdate(),
        agreementsChanged: message.assistantContentType() === 'bulk-applied'
    });
